import { render, staticRenderFns } from "./BactDataMst.vue?vue&type=template&id=6bbe20e4&scoped=true"
import script from "./BactDataMst.vue?vue&type=script&lang=js"
export * from "./BactDataMst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbe20e4",
  null
  
)

export default component.exports